import React from "react";
import PropTypes from "prop-types";
import environmentSettings from "@src/constants/environmentSettings";

export default function ErrorMessageRestart({ ...props }) {
    const { phone } = environmentSettings;

    let greeting = <p className="label-text">Hello,</p>;
    if(props.firstName) { 
        greeting = <p className="label-text">Hi {props.firstName},</p>;
    }

    return (
        <>
            {greeting}
            <p className="label-text">We apologise for the inconvenience.</p>
            <p className="label-text">Please start again by clicking the button below.</p>
            <p className="label-text">If you still experience issues, please call us on <a href={`tel:${phone}`}>{phone}</a>.</p>
        </>
    );
}

ErrorMessageRestart.propTypes = {
    firstName: PropTypes.string,
  }
